// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"5a5234d5","129":"43790e63","542":"ed5e4cbb","575":"c24cd05c"}[chunkId] + ".chunk.js";
};